const SCHOOL_DISTRICT = 3;
const SCHOOL = 4;

export interface OnboardingWriteAccess {
  dpa: boolean;
  internal: boolean;
  status: boolean;
}

export function canEditOnboardingTarget(input: {
  adminBubbleIds: string[];
  adminDistricts: { bubbleId?: string | null; schoolDistrictId?: string | null }[];
  bubbleType: number | undefined;
  isSiteAdmin: boolean;
  schoolDistrictId: string | null | undefined;
}): OnboardingWriteAccess {
  if (input.isSiteAdmin) {
    const isDistrict = input.bubbleType === SCHOOL_DISTRICT;
    return { dpa: isDistrict, internal: isDistrict, status: true };
  }

  if (input.bubbleType !== SCHOOL || !input.schoolDistrictId) {
    return { dpa: false, internal: false, status: false };
  }

  const parent = input.adminDistricts.find((district) => district.schoolDistrictId === input.schoolDistrictId);
  const status = Boolean(parent?.bubbleId && input.adminBubbleIds.includes(parent.bubbleId));
  return { dpa: false, internal: false, status };
}
